// extracted by mini-css-extract-plugin
module.exports = {"list-stats":"Stats--list-stats--2i0Jd","listStats":"Stats--list-stats--2i0Jd"};